import { useTranslation } from "react-i18next";

const rows = [
  { product: "Nike Dunk Low Panda", category: "Shoes", seller: "Top Seller A", status: "Verified", qc: "Available", guide: "Shoe Guide", updated: "2026-08-20" },
  { product: "Essentials Hoodie", category: "Hoodies", seller: "Top Seller B", status: "In Review", qc: "Available", guide: "Clothing Guide", updated: "2026-08-22" },
  { product: "Supreme Box Logo Tee", category: "T-Shirts", seller: "Top Seller C", status: "Verified", qc: "Available", guide: "Shirt Guide", updated: "2026-08-18" },
  { product: "North Face Puffer", category: "Jackets", seller: "Top Seller D", status: "Verified", qc: "Pending", guide: "Jacket Guide", updated: "2026-08-24" },
  { product: "Travis Scott AJ1", category: "Shoes", seller: "Top Seller E", status: "In Review", qc: "Available", guide: "Shoe Guide", updated: "2026-08-21" },
];

export default function SpreadsheetPreviewSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t("spreadsheetPreview.h2")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("spreadsheetPreview.copy")}
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px]">
              <thead>
                <tr className="border-b border-background-200/70 bg-background-100/50">
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t("spreadsheetPreview.columns.product")}</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t("spreadsheetPreview.columns.category")}</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t("spreadsheetPreview.columns.seller")}</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t("spreadsheetPreview.columns.status")}</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t("spreadsheetPreview.columns.qc")}</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t("spreadsheetPreview.columns.guide")}</th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">{t("spreadsheetPreview.columns.updated")}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={idx} className="border-b border-background-200/40 hover:bg-background-100/50 transition-colors">
                    <td className="px-4 py-3 text-sm text-foreground-950 font-medium">{row.product}</td>
                    <td className="px-4 py-3">
                      <span className="inline-flex px-2 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-800">{row.category}</span>
                    </td>
                    <td className="px-4 py-3 text-sm text-foreground-700">{row.seller}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${row.status === "Verified" ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-700"}`}>
                        {row.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-foreground-600">{row.qc}</td>
                    <td className="px-4 py-3">
                      <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-primary-600 hover:text-primary-700 hover:underline">{row.guide}</a>
                    </td>
                    <td className="px-4 py-3 text-sm text-foreground-500">{row.updated}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            {t("spreadsheetPreview.cta")}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}